"use strict";
// (C) 2021-2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutInitialState = void 0;
var tslib_1 = require("tslib");
var undoEnhancer_1 = require("../_infra/undoEnhancer");
exports.layoutInitialState = tslib_1.__assign({ layout: undefined, stash: {} }, undoEnhancer_1.InitialUndoState);
//# sourceMappingURL=layoutState.js.map